import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {Button} from './Button';

export const FullWidthButton = styled(Button)`
  width: 100%;
  box-shadow: none;
  border: 1px solid ${COLORS.Grey3};
`;
